var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { appLayoutClasses, appLayoutComponentName } from './app-layout-classes';
import clsx from '../utils/clsx';
var Root = styled('div', { name: appLayoutComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme;
    return ({
        maxWidth: '100%',
        display: 'flex',
        paddingTop: theme.layout.appBarHeight,
        alignItems: 'center',
        flexDirection: 'column',
    });
});
var Container = styled('div', {
    name: appLayoutComponentName,
    slot: 'Container',
})({
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
});
var Main = styled('main', {
    name: appLayoutComponentName,
    slot: 'Main',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign({ width: '100%' }, (ownerState.layout === 'fit'
        ? {
            height: "calc(100vh - ".concat(theme.tokens.size_layout_app_bar_height + theme.tokens.size_layout_app_top, "px)"),
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        }
        : {})));
});
var Content = styled('div', {
    name: appLayoutComponentName,
    slot: 'Content',
})(function (_a) {
    var _b;
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign(__assign((_b = {}, _b[theme.breakpoints.up('lg')] = {
        minWidth: theme.typography.pxToRem(1048),
    }, _b.margin = '0 auto', _b), (ownerState.layout === 'default'
        ? {
            paddingTop: theme.spacing(5),
            maxWidth: theme.typography.pxToRem(1048),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingBottom: theme.spacing(5),
        }
        : {
            width: '100%',
        })), (ownerState.layout === 'fit' && {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        overflowY: 'hidden',
    }));
});
export var AppLayout = React.forwardRef(function (props, ref) {
    var _a = props.layout, layout = _a === void 0 ? 'default' : _a, appBar = props.appBar, sidebar = props.sidebar, children = props.children, className = props.className, rootProps = __rest(props, ["layout", "appBar", "sidebar", "children", "className"]);
    return (React.createElement(Root, __assign({ ref: ref, className: clsx(appLayoutClasses.root, className) }, rootProps),
        appBar,
        React.createElement(Container, { className: appLayoutClasses.container },
            sidebar,
            React.createElement(Main, { ownerState: { layout: layout }, className: appLayoutClasses.main },
                React.createElement(Content, { ownerState: { layout: layout }, className: appLayoutClasses.content }, children)))));
});
